@let prefix = i18nPrefix();
<mat-card>
  <mat-card-content>
    <cappus-field-label
      class="block mb-4"
      [label]="`${prefix}.GALLERY`"
      [required]="galleryIdsControl | hasRequiredValidator"
    />
    @let configValue = galleryImageConfig;
    <pct-feature-file-upload-material-component
      i18nScope="FILE_UPLOAD_MATERIAL"
      [config]="configValue"
      [formControl]="galleryIdsControl"
      [hasErrorFromOutside]="
        itemsFormArray.touched && itemsFormArray.hasError('formArrayMaxLength')
      "
      [nameAttribute]="nameAttribute()"
      [service]="effectiveService()"
      (filesSelect)="onFilesSelect($event)"
    >
      <ng-template #fileListContentTpl let-loading="loading" let-uploading="uploading">
        @if (itemsFormArray.hasError('formArrayMaxLength')) {
          <div class="pb-4">
            <mat-error
              [control]="itemsFormArray"
              [overrideErrors]="{
                formArrayMaxLength: 'PAGES.COMMON.DETAILS.VALIDATORS.GALLERY_MAX_ITEMS',
              }"
            />
          </div>
        }
        <div class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-4">
          @for (
            fileResponse of selectedFiles();
            track getFileUploadResponseId(fileResponse, i);
            let i = $index
          ) {
            @let file = fileResponse.file;
            <div class="rounded-lg shadow-lg ring-1 ring-gray-500">
              <img mat-card-image [alt]="file.name" [src]="file | fileToUrl" />
              <div class="flex flex-col gap-2 w-full p-4">
                @let itemFormGroup =
                  itemsFormArray | findItemGroupById: (fileResponse | getFileUploadResponseId: i);
                @if (!(itemFormGroup | isNil)) {
                  @for (
                    translationsFormGroup of itemFormGroup.controls.translations.controls;
                    track translationsFormGroup.controls.language.value
                  ) {
                    @if (
                      startedLanguages() | includes: translationsFormGroup.controls.language.value
                    ) {
                      @let imageTranslationsFormGroupControls = translationsFormGroup.controls;
                      @let language = imageTranslationsFormGroupControls.language.value;
                      @let subtitleControl = imageTranslationsFormGroupControls.subtitle;
                      <mat-form-field class="w-full">
                        <mat-label>{{
                          `${prefix}.${language}_IMAGE_SUBTITLE` | transloco
                        }}</mat-label>
                        <input
                          matInput
                          name="subtitle"
                          type="text"
                          [formControl]="subtitleControl"
                        />
                        <mat-error [control]="subtitleControl" />
                      </mat-form-field>
                    }
                  }
                }
                <div class="flex place-content-end gap-2 w-full">
                  @let removable = configValue | isRemovable: file;
                  @let showPreview = configValue | showPreview: file;
                  @if (removable) {
                    <button
                      mat-icon-button
                      type="button"
                      [disabled]="galleryIdsControl.disabled || loading || uploading"
                      (click)="onClickRemove(fileResponse)"
                      ><mat-icon customMatSvgIcon="pct-mdi-delete"
                    /></button>
                  }
                  @if (showPreview) {
                    <button mat-icon-button type="button" (click)="onClickOpenPreview(file)">
                      <mat-icon customMatSvgIcon="pct-mdi-image-multiple" />
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </pct-feature-file-upload-material-component>
  </mat-card-content>
</mat-card>
